import { HANUMAN_COLORS } from '../hanumanColors';

const SIZE = 1080;

function wrapText(ctx, text, maxWidth) {
  const words = text.split(/\s+/);
  const lines = [];
  let current = '';
  for (const w of words) {
    const candidate = current ? `${current} ${w}` : w;
    if (ctx.measureText(candidate).width > maxWidth && current) {
      lines.push(current);
      current = w;
    } else {
      current = candidate;
    }
  }
  if (current) lines.push(current);
  return lines;
}

async function renderCanvas(reading, lang, options = {}) {
  const canvas = document.createElement('canvas');
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext('2d');

  const bg = ctx.createLinearGradient(0, 0, 0, SIZE);
  bg.addColorStop(0, '#FFFBF0');
  bg.addColorStop(1, '#FFCC80');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, SIZE, SIZE);

  ctx.strokeStyle = HANUMAN_COLORS.primary;
  ctx.lineWidth = 6;
  ctx.strokeRect(30, 30, SIZE - 60, SIZE - 60);

  ctx.font = '72px "Noto Sans Tamil", serif';
  ctx.textAlign = 'center';
  ctx.fillStyle = HANUMAN_COLORS.primary;
  ctx.fillText('🙏', SIZE / 2, 110);

  ctx.fillStyle = HANUMAN_COLORS.primaryDark;
  ctx.font = '600 44px "Noto Sans Tamil", "Playfair Display", serif';
  ctx.fillText("Hanuman's Counsel", SIZE / 2, 180);

  ctx.fillStyle = HANUMAN_COLORS.textPrimary;
  ctx.font = '600 36px "Noto Sans Devanagari", serif';
  ctx.fillText(reading.collectedLetters, SIZE / 2, 240);
  ctx.font = '400 24px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = HANUMAN_COLORS.textSecondary;
  ctx.fillText(reading.collectedLettersTa, SIZE / 2, 278);

  ctx.fillStyle = '#2C1810';
  ctx.font = '500 32px "Noto Sans Devanagari", serif';
  const devLines = wrapText(ctx, reading.verse, SIZE - 160);
  let y = 360;
  devLines.forEach(line => { ctx.fillText(line, SIZE / 2, y); y += 46; });

  ctx.font = '400 24px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = '#6B4226';
  const taLines = wrapText(ctx, reading.verse_ta, SIZE - 160);
  y += 16;
  taLines.forEach(line => { ctx.fillText(line, SIZE / 2, y); y += 34; });

  ctx.font = 'italic 400 20px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = HANUMAN_COLORS.primary;
  y += 20;
  ctx.fillText(`Hanuman Chalisa — line ${reading.chalisaLineNumber}`, SIZE / 2, y);

  const interp = lang === 'ta' ? reading.interpretation_ta : reading.interpretation_en;
  ctx.font = '400 28px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = '#2C1810';
  const iLines = wrapText(ctx, interp, SIZE - 200);
  y += 40;
  iLines.forEach(line => { ctx.fillText(line, SIZE / 2, y); y += 40; });

  if (options.isSpecialDay) {
    ctx.fillStyle = HANUMAN_COLORS.accent;
    ctx.fillRect(SIZE / 2 - 200, SIZE - 150, 400, 40);
    ctx.fillStyle = '#fff';
    ctx.font = '600 18px "Noto Sans Tamil", sans-serif';
    ctx.fillText("Hanuman's day reading", SIZE / 2, SIZE - 125);
  }

  ctx.font = '400 20px "Noto Sans Tamil", sans-serif';
  ctx.fillStyle = HANUMAN_COLORS.primaryDark;
  ctx.fillText('via JyotishSastra', SIZE / 2, SIZE - 60);

  const dataUrl = canvas.toDataURL('image/png');
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  return { dataUrl, blob };
}

export default async function hanumanShareImageRenderer(reading, lang, options) {
  return renderCanvas(reading, lang, options || {});
}
